// CategoriesList.jsx
import React from "react";
import { CategoryCard } from "./CategoryCard";

export const CategoriesList = ({
  categories,
  onCategorySelect,
  activeCategory,
}) => {
  return (
    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mt-4">
      {categories.map((category) => (
        <CategoryCard
          key={category._id} // Aseguramos usar _id de MongoDB
          icon={getIconForCategory(category.name)}
          name={category.name}
          isActive={activeCategory?._id === category._id}
          onClick={() => onCategorySelect(category)}
        />
      ))}
    </div>
  );
};

// Función helper para asignar iconos basados en el nombre de la categoría
const getIconForCategory = (categoryName) => {
  const normalizedName = categoryName.toLowerCase();

  const categoryIcons = {
    entradas: "🥗",
    "platos principales": "🍽️",
    postres: "🍰",
    bebidas: "🥤",
    vinos: "🍷",
    cervezas: "🍺",
    cafetería: "☕",
    tragos: "🍸",
  };

  return categoryIcons[normalizedName] || "🍴";
};
